import dynamic from "next/dynamic";
const ElectionPage = dynamic(() => import("@/screens/FiveStateElection"));
const PageLayout = dynamic(() => import("@/screens/Layout/PageLayout"));

import { getDataByUrl } from "@/handlers/commonApi";
import { MasterConfigContext } from "@/context/MasterConfigContext";
import useIsMobile from "@/hooks/useIsMobile";

import { useContext } from "react";

export default function ElectionTab({
  categoryNewsListData = null,
  latestStoryData = null,
  latestVideoData = null,
  electionCategory = null,
  constituencyListData = null,
}) {
  const masterConfig = useContext(MasterConfigContext);
  const biharElectionKey = masterConfig["assam_election"];
  const resultYear = biharElectionKey?.resultYear;
  const isMobileDevice = useIsMobile();
  const oldResult = {
   partyData: [
    {
        color: "#19AAED",
        partyName: "BJP+",
        partySeat: "76",
      },
      {
        color: "#FF9933",
        partyName: "CONG+",
        partySeat: "49",
      },
      
{
        color: "#CC0000",
        partyName: "OTH",
        partySeat: "1",
      },
    ]
  };
  const oldDesc =`Assam Assembly Elections Results 2026: इस बार के असम विधानसभा चुनाव में कौन मारेगा बाजी? NDA या महाजोत किसके सिर सजेगा ताज ? साल 2021 में राज्य की 126 विधानसभा सीटों पर BJP ने 93 सीटों पर अपने प्रत्याशी उतारे थे. बीजेपी ने 60 सीटों पर कामयाबी हासिल की थी. BJP की नेतृत्व वाली NDA ने कुल 126 सीटों पर प्रत्याशी उतारे थे जिसमें कुल 75 सीटों पर जीत हासिल हुई. जबकि कांग्रेस पार्टी ने 95 सीटों पर चुनाव लड़ी और 29 सीटें जीत पाई थी. कांग्रेस के नेतृत्व वाली महाजोत गंठबंधन को 50 सीटों पर सफलता मिली थी. साल 2016 में ही पहली बार NDA यहां सत्ता में आई थी.  असम में 9 अप्रैल को वोटिंग और 4 मई को रिजल्ट आ आएगा.  सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`
 
   const newDesc = oldDesc
  //  `Assam Assembly Elections Results 2025: इस बार के असम विधानसभा चुनाव में कौन मारेगा बाजी? NDA या महागठबंधन...किसको मिलेगा बहुमत? BJP के साथ मिलकर JDU कर पाएगा कमाल या RJD और कांग्रेस की जोड़ी में VIP और लेफ्ट पार्टी मिल पलट देंगी गेम? नीतीश की बनेगी सरकार या प्रशांत किशोर की भविष्यवाणी होगी सच?  सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`;

  let metaData = {
    title: `Assam Assembly Chunav  ${resultYear} Results: असम विधानसभा चुनाव रिजल्ट  ${resultYear} जानें सभी सीटों के नतीजे - NewsTak`,
    description: `Assam Assembly Election  ${resultYear} Results: असम विधानसभा चुनाव  ${resultYear} के सभी सीटों के ताज़ा नतीजे और जीत-हार के आंकड़े देखें। जानें किस पार्टी को कितनी सीटें मिलीं और कौन बना रहा है सरकार — लाइव अपडेट्स के साथ।`,
    keywords: `असम विधानसभा चुनाव ${resultYear} परिणाम, Assam Assembly Election ${resultYear} Results, Assam Chunav Result ${resultYear}, Assam Election Result Live, Assam Vidhan Sabha Result, Assam Election Seat Wise Result, असम सीटवार चुनाव नतीजे, Assam Election Winner List, असम चुनाव वोट गिनती, Assam Assembly Election Live Updates, किसे कितनी सीटें मिली असम चुनाव, Assam Election Final Result ${resultYear}`,
  };

  return (
    <section>
      <PageLayout
        latestStoryData={latestStoryData}
        latestVideoData={latestVideoData}
      >
        <ElectionPage
          categoryNewsListData={categoryNewsListData}
          // faqData={faqData}

          electionPath={`${electionCategory}/results`}
          isMobileDevice={isMobileDevice}
         
          electionPassedCategory={electionCategory} //'delhi-assembly'
          masterKey="assam_election"
          stateName={"Assam"} //"Delhi"
          stateHindi={"असम"}
          metaData={metaData}
          oldResult={oldResult}
          oldDesc={oldDesc}
          newDesc={newDesc}
          resultKey={"partiesDataBR"}
          constituencyListData={constituencyListData}
        />
      </PageLayout>
    </section>
  );
}
//staticpages?url=sample-faqs
export const getServerSideProps = async (ctx) => {
  const { logger } = await import("@/utils/logging/log-util");

  let url = ctx?.resolvedUrl;
  url = url.split("/results")[0];

  let electionCategory = url.split("/elections/")[1];
 
  if (!electionCategory) {
    return {
      notFound: true,
    };
  }

  try {
    const { getLatestContentFeed } = await import("@/handlers/content");
    const { getMasterConfig } = await import("@/handlers/masterConfig");
    const { getRedisApiKey, fetchRedisWrapper } = await import(
      "@/handlers/redisKey"
    );
    const { setPageTTL } = await import("@/utils/setPageTTL");
    const { getUnixTimeDaysAgo } = await import("@/utils/dateTimeFormat");
    const unixtime = getUnixTimeDaysAgo(15);

    let masterConfigData = await getMasterConfig();

    let categoryListRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "getdatabyurl",
        url: url,
        page: 0,
        display: 12,
        type: "all",
      },
    });

    // faq key
    // let faqRedisKey = getRedisApiKey({
    //   masterConfigData: masterConfigData,
    //   redisPrefix: "PREFIX_REDIS_ROS",
    //   params: { api: "staticpages", url: "sample-faqs" },
    // });

    //* get redis api key for each api
    const latestStoryRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "story",
        unixtime,
      },
    });
    const latestVideoRedisKey = getRedisApiKey({
      masterConfigData: masterConfigData,
      redisPrefix: "PREFIX_REDIS_ROS",
      params: {
        api: "latestcontentfeed",
        page: 0,
        display: 5,
        type: "video",
        unixtime,
      },
    });
    let electionConfigData = null;
    const electionConfig = await fetch(
      `${
        process.env.BASE_PATH + process.env.API_PREFIX
      }/staticconfig?id=masterconfig`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    ).then(async (res) => {
      return await res.json();
    });
    electionConfigData = electionConfig?.data?.assam_election;
    let constituencyListData = null;

    let constituencyUrl =
      electionConfigData?.constListYear == 2021
       ? electionConfigData?.allConstituency2021Api
        : electionConfigData?.allConstituency2026Api;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2020-all-consituency.json`;
    // `https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json`;
    await fetch(constituencyUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    }).then(async (data) => {
      const data1 = await data.json();
      // console.log("delhi-constitutency", data1);
      constituencyListData = data1; //electionConfigData?.constListYear==2020 ?  data1 : data1?.data;
    });
    let [
      categoryNewsListData,
      latestStoryData,
      latestVideoData,
      // , faqData
    ] = await Promise.all([
      fetchRedisWrapper(categoryListRedisKey, () =>
        getDataByUrl({
          url: url,
          page: 0,
          display: 12,
          type: "all",
        })
      ),
      fetchRedisWrapper(latestStoryRedisKey, () =>
        getLatestContentFeed({
          type: "story",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      fetchRedisWrapper(latestVideoRedisKey, () =>
        getLatestContentFeed({
          type: "video",
          page: 0,
          display: 5,
          unixtime,
        })
      ),
      // fetchRedisWrapper(faqRedisKey, () =>
      //   getFaqBySlug({
      //     url: "sample-faqs",
      //   })
      // ),
    ]);

    // let headerCache = categoryNewsListData?.cache;
    setPageTTL(ctx, 120);

    return {
      props: {
        categoryNewsListData,
        latestStoryData,
        latestVideoData,
        electionCategory,
        constituencyListData,
        // faqData,
      },
    };
  } catch (error) {
    logger.error(error);
    return {
      notFound: true,
    };
  }
};
